/**
 *
 * @module receipt
 *
 */

import Check from 'check-types';
import Services from './../services/entry';

const ReceiptCredentials = Services.Purchase.ReceiptCredentials;

const InvalidArgumentException = Services.Exception.InvalidArgumentException;

const {
    object,
    nonEmptyString
} = Check.assert;

/**
 *
 * @class Receipt
 *
 */
export default class Receipt {

    /**
     *
     * @param {String} store
     * @param {Object} receipt
     *
     */
    constructor(store, receipt) {

        const errorMessage = {
            ctor: 'Receipt(store, receipt)',
            get store() {
                return `${this.ctor} store should be String with length`;
            },
            get receipt() {
                return `${this.ctor} should be an Object`;
            }
        };

        object(receipt, errorMessage.receipt, InvalidArgumentException);
        nonEmptyString(store, errorMessage.store, InvalidArgumentException);

        /**
         *
         * @access private
         * @type {Object}
         * @desc contains the receipt information necessary to identify this purchase
         *
         */
        this.receiptCredentials = new ReceiptCredentials(store, receipt);

    }

}



// WEBPACK FOOTER //
// ./src/purchase/receipt.js